import {
  getDataAutomationGroup,
  getDataAutomationId,
  getDataLinkAttributes,
} from "@/helpers";
import cn from "classnames";
import { FC } from "react";
import { Button } from "../Button";
import { FeatureCardProps as FeatureCardType } from "./FeaturesOverviewLayout";

type FeatureCardProps = Omit<FeatureCardType, "featureContent"> & {
  isActive: boolean;
  index: number;
  setActiveIndex: (i: number) => void;
};

const FeatureCard: FC<FeatureCardProps> = ({
  cardContent,
  button,
  isActive,
  index,
  setActiveIndex,
}) => {
  return (
    <div
      className={cn("z-10 px-6 lg:px-8", isActive && "bg-background-highlight")}
      {...getDataAutomationGroup("card")}
    >
      <div
        className={cn(
          "flex h-full flex-col border-b-1 py-6 text-left transition-all duration-300 lg:py-8",
          isActive ? "border-swdc-silver-300" : "border-transparent",
        )}
      >
        <div className="flex flex-1 flex-col">{cardContent}</div>
        {button && (
          <Button
            className="mt-6"
            onClick={() => setActiveIndex(index)}
            variant="tertiary"
            size="m"
            icon={isActive ? "arrowUp" : "arrowDown"}
            iconPosition="right"
            {...getDataLinkAttributes({ dlt: button.dlt, dld: button?.dld })}
            {...getDataAutomationId("expandable-text-link")}
          >
            {isActive ? button.viewLess : button.viewMore}
          </Button>
        )}
      </div>
    </div>
  );
};

export default FeatureCard;
